import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap } from "rxjs/operators";
import { CommonApiService } from "src/app/services/common-api.service";
import { API } from "../../models/api.enum";
import { of } from "rxjs";
import {
  loadUpgradePlanFailure,
  loadUpgradePlanInfo,
  loadUpgradePlanSuccess,
} from "./upgrade-plan.action";
import { IUpgradePlanList } from "../../models/upgarde-plan.model";

@Injectable()
export class ViewUpgardePlanInfoEffects {
  constructor(
    private actions$: Actions,
    private commonApiService: CommonApiService
  ) {}

  loadUpgardePlanInfo$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadUpgradePlanInfo),
      mergeMap((action) => {
          const params = { _sort: action._sort };
        return this.commonApiService
          .get<IUpgradePlanList>(API.UPGARDE_PLAN)
          .pipe(
            map((upgardePlanInfo) =>
              loadUpgradePlanSuccess({ upgardePlanInfo })
            ),
            catchError((error) => of(loadUpgradePlanFailure({ error })))
          );
      })
    );
  });
}
